// Poza cardului urmează culoarea aleasă. Clic = alegere fermă; hover = doar o
// privire, care se anulează când pleacă cursorul.
//
// `committed` reține poza „adevărată" a cardului (cea de la încărcare sau cea
// aleasă prin clic), ca previzualizarea să aibă unde să se întoarcă. Cheia e
// elementul <img>, într-un WeakMap, deci se curăță singur când grila e
// re-randată de filtrare sau paginare.
const committed = new WeakMap();

function aperteApplySwatchImage(img, swatch) {
  const srcset = swatch.dataset.imageSrcset;
  const alt = swatch.dataset.imageAlt;
  if (srcset) img.srcset = srcset;
  img.src = swatch.dataset.imageSrc;
  if (alt !== undefined) img.alt = alt;
}

document.addEventListener('click', function (e) {
  const swatch = e.target.closest('.aperte-card-swatch');
  if (!swatch) return;

  e.stopPropagation();

  const card = swatch.closest('.card-wrapper');
  if (!card) return;

  // Variantele fără poză legată rămân alegibile: se marchează culoarea și se
  // schimbă varianta pentru butonul „+", doar poza cardului rămâne cea de
  // dinainte. Înainte clicul pe ele nu făcea nimic — butonul înghițea clicul,
  // dar codul ieșea imediat fiindcă nu găsea `data-image-src`.
  const src = swatch.dataset.imageSrc;
  const img = card.querySelector('.card__media img');

  if (src && img) {
    // Pe mobil, dacă poza culorii e deja în fâșia de răsfoire, sărim la ea în loc
    // s-o suprascriem pe prima — altfel fâșia ar arăta două culori amestecate.
    // Întoarce false pe desktop și ori de câte ori poza nu e în fâșie (fâșia are
    // maximum 5 poze, iar o variantă poate cădea în afara lor).
    const jumped =
      typeof window.aperteSwipeJumpToMedia === 'function' &&
      window.aperteSwipeJumpToMedia(card, swatch.dataset.mediaId);

    if (!jumped) {
      aperteApplySwatchImage(img, swatch);
      // Alegerea devine noua stare de referință; previzualizarea nu mai are la ce
      // să se întoarcă, altfel mouse-out ar readuce poza dinainte de clic.
      committed.delete(img);
    }
  }

  card.querySelectorAll('.aperte-card-swatch').forEach(function (s) {
    s.removeAttribute('aria-pressed');
  });
  swatch.setAttribute('aria-pressed', 'true');

  aperteSelectVariant(card, swatch);
});

// Clicul pe swatch alege varianta pe care o va adăuga butonul „+".
// Înlocuiește fereastra de alegere din Dawn, scoasă la cererea lui Petru.
function aperteSelectVariant(card, swatch) {
  const variantId = swatch.dataset.variantId;
  if (!variantId) return;

  const input = card.querySelector('.quick-add .product-variant-id');
  if (input) input.value = variantId;

  // Prețul trebuie să urmeze culoarea: 57 de produse active au prețuri diferite
  // între variante, iar fără asta cardul ar arăta un preț și ar adăuga altul.
  const price = swatch.dataset.variantPrice;
  if (price && typeof window.aperteSetPrice === 'function') {
    card.querySelectorAll('.card-information .price .price-item--regular').forEach(function (el) {
      window.aperteSetPrice(el, price);
    });
  }

  // Nu există momentan variante indisponibile în catalog, dar dacă apar,
  // butonul trebuie să refuze, nu să trimită o comandă care eșuează la coș.
  const button = card.querySelector('.quick-add .quick-add__submit');
  if (button && swatch.dataset.variantAvailable) {
    const available = swatch.dataset.variantAvailable === 'true';
    button.disabled = !available;
  }
}

// Previzualizare la hover, doar pe dispozitive cu cursor adevărat.
(function () {
  if (window.matchMedia && !window.matchMedia('(hover: hover)').matches) return;

  function imageFor(swatch) {
    const card = swatch.closest('.card-wrapper');
    return card ? card.querySelector('.card__media img') : null;
  }

  document.addEventListener('pointerover', function (e) {
    const swatch = e.target.closest && e.target.closest('.aperte-card-swatch');
    if (!swatch || !swatch.dataset.imageSrc) return;

    const img = imageFor(swatch);
    if (!img) return;

    if (!committed.has(img)) {
      committed.set(img, { src: img.src, srcset: img.srcset, alt: img.alt });
    }
    aperteApplySwatchImage(img, swatch);
  });

  document.addEventListener('pointerout', function (e) {
    const swatch = e.target.closest && e.target.closest('.aperte-card-swatch');
    if (!swatch || !swatch.dataset.imageSrc) return;

    // Trecerea directă pe un alt swatch nu e o ieșire — lasă `pointerover`
    // să suprascrie, altfel poza ar clipi prin starea de referință.
    const to = e.relatedTarget;
    if (to && to.closest && to.closest('.aperte-card-swatch')) return;

    const img = imageFor(swatch);
    if (!img || !committed.has(img)) return;

    const prev = committed.get(img);
    img.srcset = prev.srcset;
    img.src = prev.src;
    img.alt = prev.alt;
    committed.delete(img);
  });
})();

// Image-only hover swap.
// The full-card link overlay (.card__heading a::after) sits on top of the
// product image, so a plain CSS :hover on the media never fires. Instead we
// track the pointer and toggle `.aperte-img-hover` on the card-wrapper only
// while the cursor is actually over the .card__media box. CSS keys the
// second-image swap and zoom off that class. Delegated on document so it also
// covers grids re-rendered by filtering/pagination.
(function () {
  // Only on devices with a real hovering pointer (skip touch).
  if (window.matchMedia && !window.matchMedia('(hover: hover)').matches) return;

  var current = null; // the card-wrapper currently flagged

  function clear() {
    if (current) {
      current.classList.remove('aperte-img-hover');
      current = null;
    }
  }

  document.addEventListener(
    'pointermove',
    function (e) {
      var card = e.target.closest ? e.target.closest('.card-wrapper') : null;
      if (!card) {
        clear();
        return;
      }
      var media = card.querySelector('.card__media');
      if (!media) {
        clear();
        return;
      }
      var r = media.getBoundingClientRect();
      var inside =
        e.clientX >= r.left &&
        e.clientX <= r.right &&
        e.clientY >= r.top &&
        e.clientY <= r.bottom;

      if (inside) {
        if (current && current !== card) current.classList.remove('aperte-img-hover');
        card.classList.add('aperte-img-hover');
        current = card;
      } else {
        clear();
      }
    },
    { passive: true }
  );

  // Clear when the pointer leaves the document entirely.
  document.addEventListener('pointerleave', clear);
}());
